import { render } from "./UsernameAutocomplete.vue?vue&type=template&id=bd6b9b0c"
import script from "./UsernameAutocomplete.vue?vue&type=script&lang=js"
export * from "./UsernameAutocomplete.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__